import { useMemo } from "react";
import { useParams } from "react-router-dom-v5-compat";
import {
  CARS_SHOP_PATH,
  CAR_URL_PARAM_KEYS,
  type AvailabilityPageRouteParams,
} from "@apac/components/cars";

export const useShopLink = ({
  storeKey,
  vehicleId,
  skipStore,
}: {
  storeKey?: string;
  vehicleId?: string;
  skipStore?: boolean;
}) => {
  const { pickupLocation = "", dropoffLocation = "" } =
    useParams<AvailabilityPageRouteParams>();
  return useMemo(() => {
    const queryParams = new URLSearchParams(window.location.search);
    if (vehicleId != null) {
      queryParams.set(CAR_URL_PARAM_KEYS.VEHICLE_ID, vehicleId);
    }
    if (storeKey != null) {
      queryParams.set(CAR_URL_PARAM_KEYS.STORE_KEY, storeKey);
    }
    if (skipStore === true) {
      queryParams.set(CAR_URL_PARAM_KEYS.SKIP_STORE, "true");
    }
    return `${CARS_SHOP_PATH}/${encodeURIComponent(
      pickupLocation
    )}/${encodeURIComponent(dropoffLocation)}?${queryParams}`;
  }, [vehicleId, storeKey, skipStore, pickupLocation, dropoffLocation]);
};
